/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import log from 'salvo-lite/log'
import jQuery from 'jquery'
import Choices from 'choices.js'

class CollectionFilters {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._anchor = JSON.parse(document.querySelector('[data-tag-filter]').innerHTML).anchor
        this._href = JSON.parse(document.querySelector('[data-tag-filter]').innerHTML).href
        this._currentSortBy = JSON.parse(document.querySelector('[data-tag-filter]').innerHTML).sort_by
    }

    onInit () {
        log.debug(this.constructor.name, 'initialised', this)

        const [firstInstance, secondInstance, thirdInstance] = new Choices('.choice-filter', {
            itemSelectText: '',
            searchEnabled: false
        })
        this._onSelectChange()
    }

    _onSelectChange () {
        let tagFilters = jQuery('.tag-filter')
        let self = this

        tagFilters.change(function () {
            let newTags = []

            tagFilters.each(function () {
                if (jQuery(this).val()) {
                    newTags.push(jQuery(this).val())
                }
            })

            if (newTags.length) {
                let query = newTags.join('+')
                window.location.href = jQuery(self._anchor).attr('href').replace('/' + 'tag', '/' + query)
            } else if (self._currentSortBy.length) {
                window.location.href = `${self._href}?sort_by=${self._currentSortBy}`
            } else {
                window.location.href = self._href
            }
        })
    }
}

export default CollectionFilters



// WEBPACK FOOTER //
// ./src/resources/scripts/components/CollectionFilters.js